import React from 'react'
import './Card.css'

function CardContainer(props) {

    return (
        <div className={"card h-100 card-block"}>
            {props.title &&
                <div className="row mt-3">
                    <div className="col h4 wizard-step-title">
                        {props.title}
                    </div>
                </div>
            }
            <div className="row g-0" >
                {props.icon &&
                    <div className="col-md-3 center-parent stepIcon">
                        {props.icon}
                    </div>
                }
                <div className={props.icon == null ? "col-md-12" : "col-md-9"} style={{ display: 'flex', alignItems: "center" }}>
                    <div className="card-body">
                        {props.children}
                    </div>
                </div>
                {props.onUpdateClick != null &&
                    <button type="button" className="btn btn-primary bowl-btn card-button" onClick={props.onUpdateClick} >Update</button>
                }
            </div>
        </div>
    )
}

export default CardContainer
